import { FC, SVGProps } from 'react'
import classNames from '@ui-components-3/ui/lib/utils/classNames'

type PillProps = {
  label: string
  Icon?: FC<SVGProps<SVGSVGElement>>
  className?: string
}

const Pill = ({ label, Icon, className }: PillProps) => {
  return (
    <div
      className={classNames(
        'inline-flex items-center gap-1 bg-neutral-300 px-3 py-1 rounded-[50px] text-neutral-800 typography-small font-semibold',
        className,
      )}
    >
      {!!Icon && <Icon className="w-4 h-4 !mr-0 !fill-neutral-800" aria-hidden="true" />}
      {label}
    </div>
  )
}

export default Pill
